<template>
  <div>
    <div class="wrapp-collapse-filters">
      <div class="filter-col" v-for="(filter, attrCode) in available" :key="attrCode">
        <span class="title">{{ filter.label }}</span>
        <component
        :is="componentByCode[attrCode] || 'checkbox-filter'"
        :attrCode="attrCode"
        :options="filter.options"
        @changeFilter="$emit('changeFilter', $event)"/>
      </div>
    </div>
    <!-- IF NO FILTERS SELECTED SHOW CLOSE BUTTON -->
    <div class="wrapp-collapse-filters-ctas">
      <transition
      enter-active-class="animate__animated animate__slideInUp animate__faster"
      leave-active-class="animate__animated animate__slideOutDown animate__faster">
        <apply-filters @clear="clearFilter" @apply="applyFilter" :showClear="true" v-show="canApply"></apply-filters>
      </transition>
    </div>
  </div>
</template>

<script>
import ApplyFilters from './ApplyFilters'
import CheckboxFilter from './FiltersLayout/CheckboxFilter'
import Price from 'theme/components/Listing/FiltersLayout/Price'
import ColorFilter from 'theme/components/Listing/FiltersLayout/ColorFilter'

export default {
  computed: {
    available () {
      return this.$store.state.listing.filters.available
    },
    componentByCode () {
      return {
        'price': 'price'
      }
    },
    canApply () {
      let canApply = false
      let filtersTemporary = this.$store.state.listing.filters.temporary
      let choosen = this.$store.state.listing.filters.chosen
      let filters = { ...filtersTemporary, ...choosen }
      for (let i in filters) {
        if (filters[i].length) {
          canApply = true
          break
        }
      }
      return canApply
    }
  },
  methods: {
    applyFilter () {
      let filtersTemporary = this.$store.state.listing.filters.temporary
      for (let i in filtersTemporary) {
        let filters = this.getFilterCompose(i, filtersTemporary[i])
        this.$store.commit('listing/updateFilters', filters)
      }
      this.$emit('changeFilter')
      this.$emit('close')
    },
    clearFilter () {
      if (this.canApply) {
        // Clear filters
        // because can apply tell me that filters are selected
        this.$store.commit('listing/clearFilters')
        this.$emit('changeFilter')
      } else {
        // if no filters are active close modal
        this.$emit('close')
      }
    },
    getFilterCompose (newAttrCode, newValues) {
      return { attrCode: newAttrCode, valueSelected: newValues }
    }
  },
  components: {
    CheckboxFilter,
    ColorFilter,
    Price,
    ApplyFilters
  }
}
</script>
